import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      margin: 0 -", "px;\n\n      > ", " {\n        padding: 0 ", "px;\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  flex-wrap: wrap;\n  margin: 0 -", "px;\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  flex: 0 0 ", "%;\n  max-width: ", "%;\n  padding: 0 ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { size as themeSize } from '@scp/ui-shared/theme/variables';
export var getColumnWidth = function getColumnWidth(_ref) {
  var size = _ref.size;
  if (!size) return 100;
  var columnWidth = 100 / themeSize.gridColumnsCount;
  return (size * columnWidth).toFixed(5);
};
export var GridColumn = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['size'].includes(prop);
  }
})(_templateObject(), getColumnWidth, getColumnWidth, themeSize.gutter / 2);
export var GridWrapper = styled.div(_templateObject2(), themeSize.gutter / 2, function (props) {
  return props.narrowGutter && css(_templateObject3(), themeSize.gutterSmall / 2, GridColumn, themeSize.gutterSmall / 2);
});